// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AccessCheckRequest } from '../models';
import { AccessCheckResponse } from '../models';
import { ErrorResponse } from '../models';
import { ValidationErrorResponse } from '../models';
/**
 * AccessCheckApi - axios parameter creator
 * @export
 */
export const AccessCheckApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check access.
         * @param {Array<AccessCheckRequest>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(body?: Array<AccessCheckRequest>, options: any = {}): RequestArgs {
            const localVarPath = `/v1/access-check`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccessCheckApi - functional programming interface
 * @export
 */
export const AccessCheckApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check access.
         * @param {Array<AccessCheckRequest>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(body?: Array<AccessCheckRequest>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AccessCheckResponse>> {
            const localVarAxiosArgs = AccessCheckApiAxiosParamCreator(configuration).check(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AccessCheckApi - factory interface
 * @export
 */
export const AccessCheckApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Check access.
         * @param {Array<AccessCheckRequest>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        check(body?: Array<AccessCheckRequest>, options?: any) {
            return AccessCheckApiFp(configuration).check(body, options)(axios, basePath);
        },
    };
};

/**
 * AccessCheckApi - object-oriented interface
 * @export
 * @class AccessCheckApi
 * @extends {BaseAPI}
 */
export class AccessCheckApi extends BaseAPI {
    /**
     * 
     * @summary Check access.
     * @param {Array<AccessCheckRequest>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccessCheckApi
     */
    public check(body?: Array<AccessCheckRequest>, options?: any) {
        return AccessCheckApiFp(this.configuration).check(body, options)(this.axios, this.basePath);
    }

}
